(function () {
    'use strict';
   
    const CONFIG = {
        selectors: {
            heading: '.article__heading',
            buttonsExport: '.article__btn-export'
        }
    };
    const sitePath = window.SiteInfo?.Site?.Path ?? '';
    const siteBaseUrl = window.SiteInfo?.Site?.BaseUrl ?? '';
    const baseUrl = (siteBaseUrl || window.location.origin + sitePath);
    const citationURL = `${baseUrl}/Citation/Export`;
    document.querySelector('.grid-listing')?.classList.add('read-more');

    let isGenerating = false;

    const sanitizeFileName = (value) =>
        (value || 'article')
            .replace(/[<>:"/\\|?*]/g, '')
            .replace(/\s+/g, '_')
            .substring(0, 50);

    
    const createCitation = async (token, contentId, fileName, title) => {
        const response = await fetch(citationURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { 'RequestVerificationToken': token } : {})
            },
            body: JSON.stringify({
                ContentItemId: contentId,
                Format: 'bibtex'
            })
        });

        if (!response.ok) {
            throw new Error(`Citation export failed: ${response.status}`);
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = Object.assign(document.createElement('a'), { href: url, download: `${fileName}.bib` });
        document.body.appendChild(a);
        a.click();

        // GA4 Citation Export Event fires after successful download
        if (typeof gtag === 'function' && window.hasAnalyticsConsent && window.hasAnalyticsConsent()) {
            gtag('event', 'citation_export', {
                'export_format': 'BibTeX',
                'article_title': title
            });
        }

        a.remove();
        URL.revokeObjectURL(url);
    };

    const showToast = (message, title = 'Notice') => {
        let container = document.getElementById('pdf-toast-container');
        if (!container) {
            container = document.createElement('div');
            container.id = 'pdf-toast-container';
            container.className = 'toast-container position-fixed bottom-0 end-0 p-3';
            container.style.zIndex = '1080';
            document.body.appendChild(container);
        }

        const toastEl = document.createElement('div');
        toastEl.className = 'toast';
        toastEl.setAttribute('role', 'alert');
        toastEl.setAttribute('aria-live', 'assertive');
        toastEl.setAttribute('aria-atomic', 'true');
        toastEl.innerHTML = `
            <div class="toast-header">
                <strong class="me-auto">${title}</strong>
                <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div class="toast-body">${message}</div>
        `;

        container.appendChild(toastEl);
        const toast = new bootstrap.Toast(toastEl, { delay: 5000 });
        toast.show();
        toastEl.addEventListener('hidden.bs.toast', () => toastEl.remove());
    };

    const handleExportClick = async (e, token, contentId, fileName, title) => {
        e.preventDefault();

        if (!window.SiteInfo?.User) {
            showToast('You must be logged in to export citations.', 'Authentication Required');
            return;
        }

        if (isGenerating) return;
        isGenerating = true;

        try {
            await createCitation(token, contentId, fileName, title);
        } catch (err) {
            console.error(err);
            showToast('Citation export failed.', 'Error');
        } finally {
            isGenerating = false;
        }
    };

    const init = () => {
        const buttonsExport = document.querySelectorAll(CONFIG.selectors.buttonsExport);
        const token = document.querySelector('input[name="__RequestVerificationToken"]')?.value;
        const contentId = document.getElementById('articleContentItemId')?.value || '';
        const title = document.querySelector(CONFIG.selectors.heading)?.innerText || 'citation';
        const fileName = sanitizeFileName(title);

        buttonsExport?.forEach(btn =>
            btn.addEventListener('click', (e) => handleExportClick(e, token, contentId, `${fileName}_citation`, title))
        );
    };

    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', init)
        : init();

})();